import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { RouteMetadata } from './components/RouteMetadata'
import { HomePage } from './pages/HomePage'
import { BuyPage } from './pages/BuyPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { RefundsPage } from './pages/RefundsPage'
import { TermsPage } from './pages/TermsPage'

export function App() {
  return (
    <BrowserRouter>
      <RouteMetadata />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/buy" element={<BuyPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/refunds" element={<RefundsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}
